module.exports = __webpack_public_path__ + "img/service_intro_01@2x.21508680.png";